import styled from 'styled-components'

import { colors } from '../../constants'

const dismissAllHeight = '30px'

export const Background = styled.div`
    background: transparent;
    cursor: pointer;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
`

export const Container = styled.div`
    display: none;
    height: 100%;
    left: 60px;
    position: fixed;
    margin-top: 60px;
    top: 60px;
    transition: 0.4s all ease-in-out;
    user-select: none;
    width: 300px;
    z-index: 1000;

    ${({ open }) =>
        open &&
        `
    top: 0;
    display:block;
  `}
`

export const Frame = styled.div`
    background: ${colors.bluedarkest}d9;
    border-radius: 0px;
   /*  box-shadow: 0px 1px 4px 2px #00000042; */
    height: calc(100vh - 60px);
    padding: 10px 10px 0;
    width: 100%;
`

export const BlurTop = styled.div`
    box-shadow: 0 0px 10px 2px ${colors.bluedarkest}d9;
    position: relative;
    width: 100%;
    z-index: 3;
`

export const BlurBottom = styled.div`
    box-shadow: 0 0px 10px 2px ${colors.bluedarkest}d9;
    position: relative;
    width: 100%;
    z-index: 3;
`

export const Board = styled.div`
    height: calc(100% - ${dismissAllHeight});
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
`

export const Message = styled.div`
    background: ${colors.greylight};
    border: 1px solid ${colors.greylight};
    border-radius: 5px;
    box-shadow: 0 1px 4px #0000006b;
    float: left;
    margin-bottom: 10px;
    max-height: fit-content;
    padding: 5px;
    text-align: left;
    transform-origin: top;
    width: 100%;

    &:last-child {
        margin-bottom: 0;
    }

    ${({ withLink }) =>
        withLink &&
        `
    &:hover {
      background: ${colors.greylighter};
      border: 1px solid ${colors.grey};
      cursor: pointer;
    }
  `}

    ${({ dismissed }) =>
        dismissed &&
        `
    animation-name: dismiss-message;
    animation-duration: .3s;
    animation-fill-mode: forwards;

    @keyframes dismiss-message {
      0%    { transform: scaleY(1); }
      30%   { max-height: fit-content; }
      100% {
        transform: scaleY(0);
        margin-bottom: 0;
        max-height: 0;
        padding: 0;
      }
    }
  `}

  ${({ theme }) => {
        switch (theme) {
            case 'prompt': {
                return `
          background: ${colors.bluelighter2};
          border: 1px solid ${colors.bluelighter2};
        `
            }
            default:
                return ''
        }
    }}
`

export const Title = styled.div`
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    position: relative;
`

export const Body = styled.div`
    font-size: 14px;

    ${({ withLink }) =>
        withLink &&
        `
      cursor: pointer;
    `}
`

export const DismissButton = styled.button`
    background: transparent;
    border: 0;
    cursor: pointer;
    float: right;
    font-size: 18px;
    outline: none;
    position: absolute;
    right: 0px;
    top: 0;
`

export const DismissAllButton = styled.button`
    background: transparent;
    border: 0;
    color: ${colors.greylighter};
    cursor: pointer;
    float: right;
    font-size: 12px;
    height: ${dismissAllHeight};
    outline: none;
`
